import {Typography} from "@material-ui/core";
import React from "react";

export const SkipToClassic = ({className}) => {
    return (<div style={{
        fontSize: '2em',
        fontColor: 'gray',
        left: '70px',
        top: '74px'
    }} className={className}>
        <a href="/tv/" className={'skip-to-classic'}>
            <div style={{position: "relative", display: "flex"}}>
                <div id="arrowAnim">
                    <div className="arrowSliding">
                        <div className="arrow"></div>
                    </div>
                    <div className="arrowSliding delay1">
                        <div className="arrow"></div>
                    </div>
                    <div className="arrowSliding delay2">
                        <div className="arrow"></div>
                    </div>
                    <div className="arrowSliding delay3">
                        <div className="arrow"></div>
                    </div>
                </div>
                <div style={{marginLeft: '120px', marginTop: '-10px'}} >
                    <Typography variant={'h4'}>
                        skip to classic
                    </Typography>
                </div>
            </div>

        </a>
    </div>);
};
